const EventBooking = () => {
  const initBookingForm = form => {
    const fromSelect = form.querySelector("#fromEvent");
    const toSelect = form.querySelector("#toEvent");
    const ticketTypeInputs = form.querySelectorAll('input[name="returnType"]');
    const nextButton = form.querySelector(".event-page__booking-button");

    const TICKET_RETURN = "Day Return";

    if (!fromSelect || !toSelect || !nextButton) return;

    toSelect.disabled = true;

    // Safari does not support option.hidden on <select> elements, so we
    // remove/re-append options instead of toggling the hidden attribute.
    const allFromOptions = Array.from(fromSelect.options).filter(o => o.value);
    const allToOptions = Array.from(toSelect.options).filter(o => o.value);

    const setFromOptions = visibleOptions => {
      allFromOptions.forEach(o => {
        if (o.parentNode) fromSelect.removeChild(o);
      });
      visibleOptions.forEach(o => fromSelect.appendChild(o));
    };

    const setToOptions = visibleOptions => {
      allToOptions.forEach(o => {
        if (o.parentNode) toSelect.removeChild(o);
      });
      visibleOptions.forEach(o => toSelect.appendChild(o));
    };

    const updateButtonState = () => {
      const bothSelected = fromSelect.value && toSelect.value;
      nextButton.disabled = !bothSelected;
    };

    const updateFromOptions = () => {
      const isReturn =
        Array.from(ticketTypeInputs).find(i => i.checked).value ===
        TICKET_RETURN;

      const currentFromValue = fromSelect.value;

      const visibleFromOptions = allFromOptions.filter(
        option => !(isReturn && option.dataset.isStadium === "1")
      );

      setFromOptions(visibleFromOptions);

      // when the selected from option is no longer visible
      // we need to reset the state as its invalid
      const stillVisible = visibleFromOptions.some(
        o => o.value === currentFromValue
      );
      if (!stillVisible && currentFromValue) {
        fromSelect.value = "";
        toSelect.disabled = true;
        toSelect.value = "";
        setToOptions(allToOptions);
        updateButtonState();
      }
    };

    const updateToOptions = () => {
      const selectedFromValue = fromSelect.value;

      if (!selectedFromValue) {
        toSelect.disabled = true;
        toSelect.value = "";
        setToOptions(allToOptions);
        return;
      }

      toSelect.disabled = false;

      const selectedFromOption = allFromOptions.find(
        o => o.value === selectedFromValue
      );
      const isStadium = selectedFromOption.dataset.isStadium === "1";
      const { stadiumId, locationId } = selectedFromOption.dataset;

      // Non-stadium with a linked stadium: filter to only show that stadium stop
      const filterToLinkedStadium =
        !isStadium && stadiumId && stadiumId !== "0";

      const filterToStadiumMembers = isStadium && locationId;

      let autoSelectValue = null;

      const currentToValue = toSelect.value;

      const visibleToOptions = allToOptions.filter(option => {
        const isSameAsFrom = option.value === selectedFromValue;
        const isLinkedStadium = option.dataset.locationId === stadiumId;
        const belongsToThisStadium = option.dataset.stadiumId === locationId;

        if (isSameAsFrom) return false;
        if (filterToLinkedStadium && !isLinkedStadium) return false;
        if (filterToStadiumMembers && !belongsToThisStadium) return false;

        if (filterToLinkedStadium && isLinkedStadium) {
          autoSelectValue = option.value;
        }

        return true;
      });

      setToOptions(visibleToOptions);

      if (autoSelectValue) {
        toSelect.value = autoSelectValue;
        updateButtonState();
        return;
      }

      // If the previously selected to option is no longer visible, clear it
      if (
        currentToValue &&
        !visibleToOptions.some(o => o.value === currentToValue)
      ) {
        toSelect.value = "";
      }
    };

    nextButton.addEventListener("click", () => {
      const { bookingUrl, bookingDate } = nextButton.dataset;
      if (!bookingUrl) return;

      const checkedTicketType = Array.from(ticketTypeInputs).find(
        i => i.checked
      );

      const url = new URL(bookingUrl);
      url.searchParams.set("From", fromSelect.value);
      url.searchParams.set("To", toSelect.value);
      url.searchParams.set("Date", bookingDate);
      url.searchParams.set("TicketType", checkedTicketType.value);
      window.open(url.toString(), "_blank", "noopener,noreferrer");
    });

    ticketTypeInputs.forEach(input => {
      input.addEventListener("change", () => {
        fromSelect.value = "";
        toSelect.value = "";
        toSelect.disabled = true;
        updateFromOptions();
        updateToOptions();
        updateButtonState();
      });
    });

    fromSelect.addEventListener("change", () => {
      updateToOptions();
      updateButtonState();
    });

    toSelect.addEventListener("change", () => {
      updateButtonState();
    });

    updateFromOptions();
  };

  const init = () => {
    const bookingForms = document.querySelectorAll(".event-page__filters");
    bookingForms.forEach(form => initBookingForm(form));
  };

  return { init };
};

export default EventBooking;
